import {
  Action,
  ActionType,
  IStressSituationResponse,
} from "models/stressCheck/stressSituation";
import createReducer from "redux/createReducer";

export interface StressSituationReducerType {
  loading: boolean;
  error?: string;
  stressSituationResponse?: IStressSituationResponse;
}

const defaultState: StressSituationReducerType = {
  loading: false,
  error: undefined,
  stressSituationResponse: undefined,
};

export const stressSituationReducer = createReducer<StressSituationReducerType>(
  defaultState,
  {
    [ActionType.STRESS_SITUATION](state: StressSituationReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.STRESS_SITUATION_ERROR](
      state: StressSituationReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        stressSituationResponse: undefined,
      };
    },

    [ActionType.STRESS_SITUATION_SUCCESS](
      state: StressSituationReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        stressSituationResponse: action.payload,
      };
    },
  }
);
